export default "<app-notification></app-notification>\n<router-outlet></router-outlet>\n";